module.exports = __webpack_public_path__ + "img/Ativo 1@3x.d64625c0.png";